<script setup lang="ts">
import type { HouseDetailsResponse } from 'lc-services/modules/search/usecases/GetHouseDetails/types'

defineProps<{
  house: HouseDetailsResponse
  houseRooms: number
}>()
</script>

<template>
  <ul class="flex">
    <li class="mr-12" data-testid="transaction-rooms">
      <div class="font-bold">
        {{ houseRooms }}
      </div>
      <span class="text-gray-600">{{ $t('house.transaction.rooms') }}</span>
    </li>
    <li v-if="house.surface" class="mr-12" data-testid="transaction-surface">
      <div class="font-bold">
        {{ house.surface }} {{ $t('house.transaction.sqm') }}
      </div>
      <span class="text-gray-600">{{ $t('house.transaction.interior') }}</span>
    </li>
    <li v-if="house.domainSurface > 0" data-testid="transaction-domain-surface">
      <div class="font-bold">
        {{ house.domainSurface }} {{ $t('house.transaction.sqm') }}
      </div>
      <span class="text-gray-600">{{ $t('house.transaction.land') }}</span>
    </li>
  </ul>
</template>
